import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import BenchmarkingMedicaidService from "@app/overviews/network-benchmarking-dashboard/benchmarkingMedicaidService";
import { MedicaidFilterData } from "@app/overviews/network-benchmarking-dashboard/medicaid/filters/shared/MedicaidFilterData";

export interface MedicaidPrimaryFiltersResult {
  isLoading: boolean;
  primaryFilterData: MedicaidFilterData | undefined;
}

export const MEDICAID_PRIMARY_FILTERS_QUERY_KEY_PREFIX = "medicaid-primary-filters";

export const useMedicaidPrimaryFilters = (clientId: number | undefined, enabled: boolean): MedicaidPrimaryFiltersResult => {
  const benchmarkingMedicaidService = useMemo(() => new BenchmarkingMedicaidService(), []);

  const queryResult = useQuery<MedicaidFilterData>({
    enabled,
    queryFn: ({ signal }) => benchmarkingMedicaidService.getBenchmarkingPrimaryFilterData(signal),
    queryKey: [MEDICAID_PRIMARY_FILTERS_QUERY_KEY_PREFIX, clientId],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    isLoading: queryResult.isFetching,
    primaryFilterData: queryResult.data,
  };
}

export default useMedicaidPrimaryFilters;
